import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Form, FormControl, FormField, FormItem } from "@/components/ui/form";
import { useEffect } from "react";
import { TagSelectGuid } from "../tag/TagSelectGuid";
import { ScreenSizeSelectGuid } from "../screenSize/ScreenSizeSelectGuid";

const formSchema = z.object({
  screenSizeId: z.string(),
  tagId: z.string(),
});

export type FilterFormSchemaType = z.infer<typeof formSchema>;

interface Props {
  onChange: (values: FilterFormSchemaType) => void;
}

export const PlayerPageFilterForm: React.FC<Props> = ({ onChange }) => {
  const form = useForm<FilterFormSchemaType>({
    resolver: zodResolver(formSchema),
    defaultValues: {},
  });

  const values = form.watch();

  useEffect(() => {
    onChange(values);
  }, [onChange, JSON.stringify(values)]);

  return (
    <Form {...form}>
      <form className="sm:flex gap-2 space-y-2 sm:space-y-0">
        <FormField
          control={form.control}
          name="screenSizeId"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <ScreenSizeSelectGuid field={field} />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="tagId"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <TagSelectGuid field={field} />
              </FormControl>
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
};
